var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerNv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 5C15.6863 5 13 7.68629 13 11C13 14.3137 15.6863 17 19 17C22.3137 17 25 14.3137 25 11C25 7.68629 22.3137 5 19 5ZM11 11C11 6.58172 14.5817 3 19 3C23.4183 3 27 6.58172 27 11C27 15.4183 23.4183 19 19 19C14.5817 19 11 15.4183 11 11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 34C5 26.8203 10.8203 21 18 21H20C22.7308 21 25.2677 21.8431 27.3608 23.2833C27.8158 23.5963 27.9308 24.219 27.6178 24.6739C27.3047 25.1289 26.6821 25.244 26.2271 24.9309C24.4569 23.7129 22.3132 23 20 23H18C11.9249 23 7 27.9249 7 34V36C7 36.5523 7.44772 37 8 37H22C22.5523 37 23 37.4477 23 38C23 38.5523 22.5523 39 22 39H8C6.34315 39 5 37.6569 5 36V34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2118 29.3846C23.4013 29.1419 23.6921 29 24 29H39C39.5523 29 40 29.4477 40 30C40 30.5523 39.5523 31 39 31H25.2808L26.7808 37H37C37.5523 37 38 37.4477 38 38C38 38.5523 37.5523 39 37 39H26C25.5411 39 25.1411 38.6877 25.0299 38.2425L23.0299 30.2425C22.9552 29.9438 23.0223 29.6273 23.2118 29.3846Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 42C36.4477 42 36 42.4477 36 43C36 43.5523 36.4477 44 37 44C37.5523 44 38 43.5523 38 43C38 42.4477 37.5523 42 37 42ZM40 43C40 44.6569 38.6569 46 37 46C35.3431 46 34 44.6569 34 43C34 41.3431 35.3431 40 37 40C38.6569 40 40 41.3431 40 43Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 42C26.4477 42 26 42.4477 26 43C26 43.5523 26.4477 44 27 44C27.5523 44 28 43.5523 28 43C28 42.4477 27.5523 42 27 42ZM30 43C30 44.6569 28.6569 46 27 46C25.3431 46 24 44.6569 24 43C24 41.3431 25.3431 40 27 40C28.6569 40 30 41.3431 30 43Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0385 26.7253C40.1611 26.296 40.5535 26 41 26H44C44.5523 26 45 26.4477 45 27C45 27.5523 44.5523 28 44 28H41.7543L37.9615 41.2747C37.8389 41.704 37.4465 42 37 42H27C26.4477 42 26 41.5523 26 41C26 40.4477 26.4477 40 27 40H36.2457L40.0385 26.7253Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerNv);
export default __webpack_public_path__ + "static/media/Customer_nv.08305c1d1d5e990f0534585cf7bde4cb.svg";
export { ForwardRef as ReactComponent };